import { apiClient } from '@common/api'

/**
 * fraudQueues API service
 * Converted from AngularJS: api.fraudQueues.js
 * Endpoint: GET /fraudqueues
 */

export interface FraudQueue {
    id: number
    name: string
    isFraudCaseQueue: boolean
}

export const fraudQueuesApi = {
    get: () =>
        apiClient.get<FraudQueue[]>('/fraudqueues'),
}
